jQuery(document).ready(function ($) {
	// Resource
	$('.Shortcodes-hamburger').click(function () {
		$('.Shortcodes-mobile-nav-resource').css("display", "initial");
		$('body').css("overflow", "hidden");
	});

	$('.Shortcodes-close-icon').click(function () {
		$('.Shortcodes-mobile-nav-resource').css("display", "none");
		$('body').css("overflow", "initial");
	});

	$('.Shortcodes-show-results').click(function () {
		$('.Shortcodes-mobile-nav-resource').css("display", "none");
		$('body').css("overflow", "initial");
	});

	$('[data-sf-field-type="taxonomy"]').click(function () {
		this.classList.toggle('active');
	});

	$('.Shortcodes .search-filter-query').addClass("grid-x grid-padding-x grid-padding-y");

	$('.search-filter-results').addClass("grid-x grid-padding-x grid-padding-y");

	$('.search-filter-query').addClass("grid-x grid-padding-x grid-padding-y");

	// Select the target element
	const targetElement = document.querySelector('.search-filter-query');

	// Create a MutationObserver callback
	const observer = new MutationObserver(() => {
		if (!targetElement.classList.contains('grid-x')) {
			targetElement.classList.add('grid-x', 'grid-padding-x', 'grid-padding-y');
		}
	});

	// Configure the observer to look for attribute or class changes
	observer.observe(targetElement, {attributes: true, childList: true, subtree: true});

	// Initially add the classes if not already present
	if (targetElement && !targetElement.classList.contains('grid-x')) {
		targetElement.classList.add('grid-x', 'grid-padding-x', 'grid-padding-y');
	}

	$('.search-filter-reset').click(function () {
		$(".searchandfilter").trigger("reset");
	});
});




